import styled from 'styled-components'

export const OVERLAY_Z_INDEX = 1

export default styled.div<{ rounded?: boolean }>`
  position: absolute;
  z-index: ${OVERLAY_Z_INDEX};
  background-color: ${({ theme }) => theme['-ds-core-300'].value};
  background: linear-gradient(
    180deg,
    rgba(12, 57, 63, 0) 0%,
    rgba(12, 57, 63, 0.5) 70%,
    rgba(12, 57, 63, 1) 100%
  );
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  ${({ rounded }) =>
    rounded &&
    `
    border-radius: 6px;
  `}
`
